/**
 * ErrorLogViewComponent  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { useMemo } from "react";
import { TViewComponent } from "../../../view/IView";
import { Layout } from "../../../ui/components/Layout/Layout";
import { ResourceDebugView } from "./ResourceDebugView";
import { ResourceDebugViewDebugger } from "./components";

export const ResourceDebugViewComponent: TViewComponent<ResourceDebugView> = ({ view }) => {
	const layoutState = useMemo(() => view.getLayout(), []);

	const renderComponent = (componentName: string) => {
		switch (componentName) {
			case "debugger": {
				return <ResourceDebugViewDebugger view={view} />;
			}

			default: {
				return <p>Error: Undefined panel {componentName}.</p>;
			}
		}
	};

	return <Layout state={layoutState} renderComponent={renderComponent} />;
};
